<template>
    <div class="message-print-header">
        <div class="header">
            <div class="logo">
                <img src="css/logo_SAPOMail.svg" alt="SAPO Mail" />
            </div>
            <span>
                <span>{{identity.id}} </span>
                <small>&lt;{{identity.email}}&gt;</small>
            </span>
        </div>

        <div class="subject">{{message.subject}}</div>
        
        <div class="align-right">
            <div class="date">
                  {{message.date.full}}
            </div>
            <div class="attach-header" v-if="message.attachments.count > 1">
                <i class="fas fa-paperclip"></i>
                <small>{{message.attachments.count}} {{Language.say(message.attachments.count > 1 ? "messages.open.attachments.multiple" : "messages.open.attachments.one" )}}</small>
            </div>
        </div>


        <div class="contact">
            <small>{{Language.say('messages.details.from')}}</small>
            <span>
                <span>{{message.recipients.from.name}}</span>
                <small>&lt;{{message.recipients.from.email}}&gt;</small>
            </span>
        </div>

        <div class="contact-list">
            <div class="contact" v-if="message.recipients.to.length > 0">
                <small>{{Language.say('messages.details.to')}}</small>
                <span
                      v-for="recipient in message.recipients.to" :key='recipient.email'
                    >
                    <span>{{recipient.name}} </span>
                    <small>&lt;{{recipient.email}}&gt;,</small>
                </span>
            </div>

            <div v-if="message.recipients.cc.length > 0" class="contact">
                <small>{{Language.say('messages.details.cc')}}</small>
                <span
                  v-for="recipient in message.recipients.cc" :key='recipient.email'
                >
                    <span>{{recipient.name}} </span>
                    <small>&lt;{{recipient.email}}&gt;,</small>
                </span>
            </div>

            <div v-if="message.recipients.bcc.length > 0" class="contact">
                <small>{{Language.say('messages.details.bcc')}}</small>
                <span 
                  v-for="recipient in message.recipients.bcc" :key='recipient.email'
                >
                    <span>{{recipient.name}} </span>
                    <small>&lt;{{recipient.email}}&gt;,</small>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
  import {defineProps}        from 'vue';
  import Language             from '@/js/Shared/Language/Language.js'

  const props = defineProps({
    message : {
      required : true,
    },
    identity : {
      required : true,
    },
  })

</script>
